export const loanProviderDetails = [
  { name: 'Service Finance Company, LLC', code: 'svcfin' },
]